import {Component, Inject, OnInit} from '@angular/core';

import {HttpService} from '../services/HttpService';
import {NotificationService} from '../services/NotificationService';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import swal from 'sweetalert2';

@Component({
    selector: 'app-view-admins',
    templateUrl: './view-admins.component.html',
    styleUrls: ['./view-admins.component.scss'],
    providers: [HttpService, NotificationService]
})
export class ViewAdminsComponent implements OnInit {
    public allUsers: any;
    public User_Details: any;
    public loading: boolean = false;
    public brandDetails: any;
    public newAdminDetails = {
        name: '',
        surname: '',
        email: '',
        phone: ''
    };

    constructor(
        public dialogRef: MatDialogRef<ViewAdminsComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public http: HttpService,
        public notification: NotificationService,
    ) {
    }

    ngOnInit() {
        this.User_Details = JSON.parse(localStorage.getItem('Admin_User_Details'));
        this.allUsers = this.data.brandDetails.admins;
        this.brandDetails = this.data.brandDetails;
    }

    closeDialog() {
        this.dialogRef.close({changedBrand: this.brandDetails});
    }

    addNewAdmin() {
        console.log(this.newAdminDetails);
        this.loading = true;
        this.http.makeRequestPost(['admin/brands/user/insert', {
            token: this.User_Details.token,
            id: this.brandDetails.id,
            name: this.newAdminDetails.name,
            surname: this.newAdminDetails.name,
            email: this.newAdminDetails.email,
            phone: this.newAdminDetails.phone,
        }])
        .subscribe(
            (response) => {
                
                if (response.data) {
                    this.brandDetails = response.data;
                    this.allUsers = this.brandDetails.admins;
                    this.newAdminDetails = {
                        name: '',
                        email: '',
                        phone: '',
                        surname: '',
                    };
                }
                if (response.error) {
                    console.log("*** response.error")
                    console.log(response.error)
                    if (response.error == 'Could not find the user') {
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                    else if (response.error == 'Could not find the brand') {
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                    else if (response.error == 'Could not create the user') {
                        this.notification.showNotification('Could not create the new user', 'Error', 'error');
                    }
                    else if (response.error == 'The email has already been taken.') {
                        this.notification.showNotification('The email has already been taken.', 'Error', 'error');
                    }
                }
                this.loading = false;

            },
            (error) => {
                // error = JSON.parse(error._body);
                console.log(error);
                console.log("Error code: " + error.error.code);
                this.loading = false;
                if (error.error.code == 422) {
                    this.notification.showNotification(error.error.error.email);
                }
                else {
                    this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                }


            }
        )
    }

    removeBrandAdmin(user) {
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to remove this user as a brand admin?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            if (data.value) {
                console.log(data.value);
                this.loading = true;
                this.http.makeRequestPost(['admin/brands/user/delete', {
                    token: this.User_Details.token,
                    id: user.pivot.brand_id,
                    user_id: user.id
                }])
                .subscribe(
                    (response) => {
                        this.loading = false;
                        if (response.data) {
                            this.notification.showNotification('The user is no longer an admin for this brand', 'Success', 'success');
                            for (var i = 0; i < this.allUsers.length; i++) {
                                if (this.allUsers[i].id == user.id) {
                                    this.allUsers.splice(i, 1);
                                }
                            }
                        }
                        if (response.error) {
                            this.notification.showNotification('Could not remove the user as a brand admin', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }
        }).catch(swal.noop);
    }

}



// WEBPACK FOOTER //
// ./src/app/view-admins/view-admins.component.ts